// extracted by mini-css-extract-plugin
module.exports = {"set-phone__modal-phone":"_7c34ce","set-phone__phone-content":"ff76fa","set-phone__phone-text":"_38e117","set-phone__phone-buttons":"_969ccf","set-phone__phone-cancel":"_069190"};